import { Alert, Snackbar } from "@mui/material";

interface Props {
  open: boolean;
  onClose: VoidFunction;
}

export function PartnersAddedToast(props: Props) {
  const { open, onClose } = props;

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity="success" sx={{ width: "100%" }}>
        Partners added. They&apos;ve been sent an email and an in-app
        notification.
      </Alert>
    </Snackbar>
  );
}
